module.exports = __webpack_public_path__ + "img/DE01822.b9dc428d.png";